import { get } from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import { API, getServerConfig } from '../../api';

const getFilters = ({ filters }) => filters;

function* fetchOptions(searchTerm, filters, filterKey) {
  const serverConfig = yield select(getServerConfig);
  let filterSource = filters;
  if (filters[0].type === 'PARENT') {
    filterSource = filters[0].filters;
  }
  try {
    const filterDef = filterSource.find((f) => f.key === filterKey);
    const columnName = filterKey.split('+')[0];
    const path = `/autocomplete/${serverConfig.namespace}?${columnName}=${filterDef.operator}%3A${searchTerm}&props=${columnName}${
      filterDef.provider ? `&provider=${filterDef.provider}`
      : ''
    }${
      filterDef.source ? `&source=${filterDef.source}`
      : ''
    }`;
    const result = yield call(API, 'get', 'api', path);

    return result;
  } catch (e) {
    console.error(e);
  }
  return null;
}

export function* fetchAutocompleteOptions(action) {
  const searchTerm = get(action, 'payload.searchTerm');
  const filterKey = get(action, 'payload.filterKey');
  const filters = yield select(getFilters);

  if (searchTerm === '' || searchTerm === null) {
    yield put({
      type: 'SET_DYNAMIC_FILTER_OPTIONS',
      payload: {
        filterResults: {
          [filterKey]: [],
        },
      },
    });
  } else {
    const optionsResults = yield call(
      fetchOptions,
      searchTerm,
      filters,
      filterKey,
    );

    yield put({
      type: 'SET_DYNAMIC_FILTER_OPTIONS',
      payload: {
        filterResults: {
          [filterKey]: optionsResults.results,
        },
      },
    });
  }
}
